import React, { useState } from "react";
import { Tabs as MuiTabs, Tab } from "@material-ui/core";
import TabContext from "@material-ui/lab/TabContext";

// Map for tab alignment
const tabsAlign = {
  left: "flex-start",
  center: "center",
  right: "flex-end",
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

export default function Tabs({
  defaultActive,
  tabs,
  align = "left",
  background = "#407A28",
  text = "white",
  selectedColor = "#E8F5E1",
  selectedTabColor = "#407A28",
  boxShadow = true,
}) {
  const [active, setActive] = useState(defaultActive);
  const handleChange = (_, selected) => {
    setActive(selected);
  };

  // For Material-UI Tab components, we need some styles as classes
  // These cannot be applied as inline styles
  return (
    <div>
      <style>
        {`
          .tab {
            box-shadow: ${
              boxShadow
                ? "0px 1px 10px rgba(0, 0, 0, 0.2), 0px 4px 5px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.14)"
                : "none"
            };
            background-color: ${background};
            color: ${text};
            opacity: 1;
          }

          .Mui-selected {
            background-color: ${selectedTabColor};
          }

          .MuiTab-textColorInherit.Mui-selected {
            color: ${selectedColor};
          }

          .MuiTabs-indicator {
            background-color: ${selectedColor};
          }

          .MuiTabs-scroller {
            flex: 0 1 auto;
          }

          .MuiTabs-root {
            justify-content: ${tabsAlign[align]};
          }

          .MuiTabs-scrollButtons {
            @media (max-width: 800px) {
              display: inline-flex;
            }
          }
        `}
      </style>
      <TabContext value={active}>
        <MuiTabs
          value={active}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          {tabs.map(({ label }, index) => (
            <Tab
              value={String(index)}
              label={<div>{label}</div>}
              key={index}
              className="tab"
              {...a11yProps(index)}
            />
          ))}
        </MuiTabs>
        {tabs.map(({ tabPanel }, index) => (
          <div
            role="tabpanel"
            aria-hidden={active !== String(index)}
            id={`scrollable-auto-tabpanel-${index}`}
            key={index}
          >
            {active === String(index) && tabPanel}
          </div>
        ))}
      </TabContext>
    </div>
  );
}
